import { Dialog } from "@headlessui/react";
import type { ReactNode } from "react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  panelClassName?: string;
  overlayClassName?: string;
  containerClassName?: string;
};

const Modal = ({
  isOpen,
  onClose,
  children,
  panelClassName,
  overlayClassName,
  containerClassName,
}: ModalProps) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    className={containerClassName || "fixed inset-0 z-[200] overflow-y-auto"}
  >
    <div className="flex min-h-screen items-center justify-center p-4">
      <Dialog.Overlay
        className={overlayClassName || "fixed inset-0 bg-black opacity-50"}
      />
      <div className={`relative ${panelClassName || ""}`}>{children}</div>
    </div>
  </Dialog>
);

export default Modal;
